import { render, staticRenderFns } from "./MemberQuoteCard.vue?vue&type=template&id=49f21dfc&scoped=true&"
import script from "./MemberQuoteCard.vue?vue&type=script&lang=ts&"
export * from "./MemberQuoteCard.vue?vue&type=script&lang=ts&"
import style0 from "./MemberQuoteCard.vue?vue&type=style&index=0&id=49f21dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f21dfc",
  null
  
)

export default component.exports